import MainApp from "./MainApp.container";

export default MainApp;
